import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=1fd2a1a1&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2a1a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd2a1a1')) {
      api.createRecord('1fd2a1a1', component.options)
    } else {
      api.reload('1fd2a1a1', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=1fd2a1a1&scoped=true", function () {
      api.rerender('1fd2a1a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Modal/Profile.vue"
export default component.exports